module.exports = __webpack_public_path__ + "img/i1.f4487e9d.png";